import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import Toast from 'vue-toastification';
import "vue-toastification/dist/index.css";
import 'devextreme/dist/css/dx.light.css';
import "./utils/mixin";
import axios from 'axios'
import { VueMaskDirective } from 'v-mask'
import store from './store'
import moment from "moment";
import excel from 'vue-excel-export'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
});

Vue.use(excel)

Vue.mixin({
  methods: {
    notify(text, type = "success") {
      setTimeout(() => this.$root.$emit("notify", { text, type }), 100);
    },

    formatPrice(value) {
      let val = (+value).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY")
    },

    minutesToTime(minutos) {
      const horas = Math.floor(minutos / 60);
      const min = minutos % 60;
      const textoHoras = (`00${horas}`).slice(-2);
      const textoMinutos = (`00${min}`).slice(-2);

      return `${textoHoras}:${textoMinutos}`;
    },
    converterHorasEmMinutos (hora) {
      const arrHora = hora.split(':');
      return parseInt(arrHora[0]) * 60 + parseInt(arrHora[1]);
    }
  },
});


Vue.directive('mask', VueMaskDirective);

axios.defaults.headers.common = {
  'x-access-token': localStorage.getItem('x-access-token'),
};

let baseURL = 'https://assistencia.zagonel.com.br/api-assistencia/';
if (document.URL.indexOf('localhost') !== -1) {
  baseURL =  'http://localhost:9350/';
}

const http = axios.create({ baseURL });

http.interceptors.request.use(req => {
  http.defaults.headers.common = {
    'x-access-token': localStorage.getItem('x-access-token')
  };
  return req;
});

Vue.prototype.$http = http;
Vue.prototype.$urlAPI = baseURL;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
